import React, { Component } from "react";
import Box from "@mui/material/Box";
import Sidebar from "./Sidebar";
import { Divider, Paper, Typography,LinearProgress, Backdrop, CircularProgress,
  TableBody,
  Table,
  TableContainer,
  TablePagination,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
  Button,
 } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import CountUp from "react-countup";
import Diversity3Icon from '@mui/icons-material/Diversity3';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import Appbar from '../../src/admin_panel_crm/Appbar'
import base from '../base.json'
import moment from 'moment'





const drawerWidth = 80;
export class Payment extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      tab : 'one',
      is_loader_open : false,



     paymentList : [],
     page : 0,
     rowsPerPage : 10,
     propertyCount : 0,


      paymentData : "",



      data:""



    
    }
  }
 



async componentDidMount(){
this.instantRetrive()

    let  m =  await sessionStorage.getItem("data")
    let  ll = JSON.parse(m)
    this.setState({data:ll})
      fetch(
           `${base.base_url}/property_portal/vendor_portal/payment/retrivePaymentList/:${this.state.page}/:${this.state.rowsPerPage}/:${ll[0].builder_id}`,
           {headers: {
                      "Content-Type":"application/json"
                        },
             method: "get",
           }
          )
           .then((res) => {
             return res.json();
           })
           .then((result) => {
             this.setState({
               paymentList: result.data,
               propertyCount: result.size,
               paymentData:result.paymentData,
               is_loader_shows : false
             });
           });
     

      
}


  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.instantRetrive();
    });
  };



  handleChangeRowsPerPage = (event) => {
    this.setState(
      { rowsPerPage: parseInt(event.target.value, 10), page: 0 },
      () => {
        this.instantRetrive();
      }
    );
  };


    instantRetrive = async() => {
             let  m =  await sessionStorage.getItem("data")
      let  ll = JSON.parse(m)
        fetch(
             `${base.base_url}/property_portal/vendor_portal/payment/retrivePaymentList/:${this.state.page}/:${this.state.rowsPerPage}/:${ll[0].builder_id}`,
             {headers: {
                        "Content-Type":"application/json"
                          },
               method: "get",
             }
            )
             .then((res) => {
               return res.json();
             })
             .then((result) => {
               this.setState({
                 paymentList: result.data,
                 propertyCount: result.size,
                 paymentData:result.paymentData,
                 is_loader_shows : false
               });
             });



             
                 fetch(`${base.base_url}/property_portal/vendor_portal/builder/loginBuilder`, {
                   headers:{
                     'authorization': `Bearer ${sessionStorage.getItem('token')}`,
                 'content-type':'application/json',
                // 'Access-Control-Allow-Origin': 'http://localhost:3000',
                   },
                       method: "post",
                       body:JSON.stringify({
                                   builder_email_id: ll[0].builder_email_id,
                                   builder_login_passcode: ll[0].builder_login_passcode,
                         })
               
                     }).then(function(response) {
                       return response.json();
                     })
                     .then(async(data)=> {

                   
             
                      
                       await sessionStorage.setItem('data',JSON.stringify(data.data))
                
                     
                     });
    };
  



addPayment=async()=>{

    let  m =  await sessionStorage.getItem("data")
    let  ll = JSON.parse(m)
    const options = {
      key: base.api,
      amount: 20000, 
      currency: "INR",
      name: "Makaan Media",
      description: "",
       
      handler: (response) => {

               fetch(`${base.base_url}/property_portal/vendor_portal/payment/AddNewPayments`, {
                 headers:{
                  // 'authorization': `Bearer ${sessionStorage.getItem('token')}`,
                   'content-type':'application/json',
              // 'Access-Control-Allow-Origin': 'http://localhost:3000',
                 },
                     method: "post",
                     body:JSON.stringify({
                        response:response,
                        user_id: ll[0].builder_id,
                       })
             
                   }).then(function(response) {
                     return response.json();
                   })
                   .then((data)=> {
                    
                       this.setState({
                        paymentData : data.data,
                        data:data.data[0]
                       })
                        this.instantRetrive();

                   });

      },
      theme: {
        color: "#F37254",
      },
    };

    let rzp = new window.Razorpay(options);
    rzp.open();
}




  render() {


    return (
  <Box>
    <Appbar/>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
<Box sx={{height:'100%',width:'100%'}}>

{
  /// header data
}
<Box  sx={{height:47,width:'100%',backgroundColor:'#fff',borderRadius:0,mt:0.2,borderBottom:0.5,borderBottomColor:'#dddddd'}}>
<Tabs
  value={this.state.tab}
  onChange={this.handleChange}
  aria-label="wrapped label tabs example"
>
  <Tab
    value="one"
    sx={{textTransform:'none',fontWeight:'500',fontSize:15}}
    label="Payments"
    wrapped
  />
</Tabs>
</Box>



<Box sx={{padding:3}}>
<Grid container spacing={1}>
  <Grid size={{xs:12,sm:6,md:2.4}}>

    <Paper sx={{width:'100%',height:110, background: 'linear-gradient(to right bottom, #c54d07, #096b00)'}}>
      <Box sx={{padding:1.5}}>
        <Typography sx={{fontSize:12,fontWeight:'800',fontFamily:'sans-serif',color:'#fff'}}>TOTAL PAID AMOUNT</Typography>
         <Typography sx={{fontSize:20,fontWeight:'550',fontFamily:'sans-serif',color:'#fff',mt:0.5}}> ₹ <CountUp start={0} end={this.state.paymentData?this.state.paymentData[0].balence:0}/>  </Typography>
         <Box sx={{width:'100%',height:40,display:'flex',justifyContent:'right'}}>
         <Box sx={{height:40,width:140,backgroundColor:'#fcfcfc',borderRadius:1,display:'flex',justifyContent:'center',alignItems:'center',mb:5}}>
             <Button onClick={this.addPayment} startIcon={<CurrencyRupeeIcon/>} variant="contained" sx={{fontSize:12,textTransform:'none',height:25}}>Add Money</Button>
         </Box>
     </Box>
    </Box>
    </Paper>

  </Grid>

    <Grid size={{xs:12,sm:6,md:2.4}}>

    <Paper sx={{width:'100%',height:110, background: 'linear-gradient(to right bottom, #07c520, #14006b)'}}>
      <Box sx={{padding:1.5}}>
        <Typography sx={{fontSize:12,fontWeight:'800',fontFamily:'sans-serif',color:'#fff'}}>TOTAL PROPERTY CAN ADD</Typography>
         <Typography sx={{fontSize:20,fontWeight:'550',fontFamily:'sans-serif',color:'#fff',mt:0.5}}>{this.state.data[0]?.Number_of_propert_listed_for_paid}  </Typography>
         <Box sx={{width:'100%',height:40,display:'flex',justifyContent:'right'}}>

     </Box>
    </Box>
    </Paper>

  </Grid>



</Grid>
</Box>





        <Box sx={{padding: 2 }}>
                <Paper
                  variant="outlined"
                  sx={{ minHeight: 250, width: "100%" }}
                >
                  <TableContainer
                    component={Box}
                    sx={{ backgroundColor: "#f4f4f6" }}
                  >
                    <Table
                      sx={{ minWidth: 620 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Transaction ID
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Amount
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                          status
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                            Date
                          </TableCell>
                     
                    
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.paymentList.map((row, index) => (
                          <TableRow
                            key={row._id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                              backgroundColor: index % 2 ? "#f9f9f9" : "#fff",
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{ color: "#42526e" }}
                            >
                              <Box
                                sx={{
                                  height: 20,
                                  minWidth: 60,
                                  display: "flex",
                                  justifyContent: "left",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 12,
                                    fontWeight: 600,
                                    paddingLeft: 1,
                                    paddingRight: 1,
                                  }}
                                >
                                 {row.payment_details?.razorpay_payment_id}
                                </Typography>
                              </Box>
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{
                                color: "#42526e",
                                textTransform: "uppercase",
                                minWidth: 100,
                              }}
                            >
                              <Box
                                sx={{
                                  height: 20,
                                  minWidth: 60,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 11,
                                    fontWeight: "500",
                                    paddingLeft: 1,
                                    paddingRight: 1,
                                  }}
                                >
                                  500.00 ₹
                                </Typography>
                              </Box>
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{
                                color: "#86fa96",
                                textTransform: "capitalize",
                                fontSize: 12,
                                fontWeight:'600'
                              }}
                            >
                                Success
                            </TableCell>
                             <TableCell
                              align="right"
                              sx={{
                                color: "#42526e",
                                textTransform: "capitalize",
                                fontSize: 12,
                                fontWeight:'600'
                              }}
                            >
                                {moment(row.date).format('YYYY-MM-DD hh:mm:ss')}
                            </TableCell>

          
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Divider />
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={this.state.propertyCount}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </Paper>
              </Box>




  </Box>    

</Box>


<Backdrop
  sx={(theme) => ({ color: '#fff',backgroundColor:'transparent',  zIndex: theme.zIndex.drawer + 1})}
  open={this.state.is_loader_open}
  onClick={this.handleClose}
>
<CircularProgress sx={{color:"#008ffb"}} />
</Backdrop>



      </Box>
   </Box>
    );
  }
}

export default Payment;
